export const DAY_IN_SECONDS = 3600;
export const CURRENT_OPEN_API_TRANSFORM_VERSION = '2.0.0';
